import { Button } from '@/components/ui/button';
import { CheckCircle2, RotateCcw, Trash2 } from 'lucide-react';

export interface BulkActionsBarProps {
  selectedCount: number;
  isDeletedTab: boolean;
  onDelete: () => void;
  onResolve: () => void;
  /**
   * What the resolve action is CALLED on this tab. Follow-up rows are already resolved, so there
   * the same button clears the deferral date instead, and the label has to say so — a button named
   * "Resolve" that resolves nothing is how an operator learns to distrust the whole bar.
   */
  resolveLabel?: string;
  onRestore: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
  isResolving?: boolean;
  isRestoring?: boolean;
}

export function BulkActionsBar({
  selectedCount,
  isDeletedTab,
  onDelete,
  onResolve,
  resolveLabel = 'Resolve',
  onRestore,
  onCancel,
  isDeleting = false,
  isResolving = false,
  isRestoring = false,
}: BulkActionsBarProps): JSX.Element {
  return (
    <div className="flex items-center justify-between border-b bg-accent/50 px-4 py-2">
      <span className="text-sm font-medium">{selectedCount} selected</span>
      <div className="flex items-center gap-2">
        {isDeletedTab ? (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={onRestore}
              disabled={isRestoring}
            >
              <RotateCcw className="mr-1 h-4 w-4" />
              {isRestoring ? 'Restoring...' : 'Restore'}
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={onResolve}
              disabled={isResolving}
            >
              <CheckCircle2 className="mr-1 h-4 w-4" />
              {isResolving ? 'Working...' : resolveLabel}
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={onDelete}
              disabled={isDeleting}
            >
              <Trash2 className="mr-1 h-4 w-4" />
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </>
        )}
        <Button variant="ghost" size="sm" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
